import { GradientText } from '@/src/common/components/marketing/heros/StyledComponents'
import {
    CardImageContainer,
    LabelText,
    LineItemContainer,
    LineItemInfoContainer,
    ProductNameText,
    TextContainer,
    ValueText,
} from '@/src/modules/OrderStatus/StyledComponents'
import LineItemDetailsPhysical from '@/src/modules/OrderStatus/content/LineItemDetailsPhysical'
import { TBoxItemSummaryProps } from '@/src/modules/OrderStatus/types'
import {
    getCustomerFacingItemStatus,
    getDeliveryStep,
} from '@/src/modules/OrderStatus/utilities'
import SimplifiedBoxImageWithCard from '@/src/modules/gift-box/content/SimplifiedBoxImageWithCard'
import { DeliveryTracker } from '@/src/common/components/elements/DeliveryTracker/DeliveryTracker'

const BoxLineItemSummary = ({
    lineItem,
    deliveryDetails,
    virtualRedemptionEmailsSent,
    orderStatus,
    quantity,
    isMultipleShipments,
}: TBoxItemSummaryProps & { quantity: number }) => {
    const {
        eGiftOpened,
        isUSPS,
        design,
        product,
        voidedReason,
        denomination,
        refund,
        status,
        parsed_imb_data: imbData,
    } = lineItem
    const { custom, predesign } = design
    const { giftBrand } = product
    const { fullyRefunded } = refund
    const denomInDollars = denomination.toFixed(2)
    const imageForPhysical: string = custom ? custom : predesign
    const giftLabel: string = `Plastic ${giftBrand} Box`
    const isVoided: boolean = !!voidedReason
    const showDeliveryTracker: boolean =
        isUSPS && !!imbData && isMultipleShipments

    const finalStatus = getCustomerFacingItemStatus(
        virtualRedemptionEmailsSent,
        status,
        orderStatus,
        true,
        isVoided,
        isUSPS,
        lineItem,
        eGiftOpened,
        fullyRefunded
    )

    return (
        <LineItemContainer>
            <CardImageContainer>
                <SimplifiedBoxImageWithCard designImage={imageForPhysical} />
                {showDeliveryTracker && (
                    <DeliveryTracker
                        step={getDeliveryStep({
                            orderStatus: orderStatus,
                            lineItemStatus: status,
                        })}
                    />
                )}
            </CardImageContainer>
            <LineItemInfoContainer>
                <TextContainer style={{ marginBottom: 0 }}>
                    <ProductNameText data-testid={'gift-label'}>
                        {giftLabel}
                    </ProductNameText>
                </TextContainer>
                <TextContainer>
                    <ValueText data-testid={'quantity'} size={3}>
                        <span style={{ textTransform: 'lowercase' }}>x</span>
                        {quantity} Plastic Visa Cards
                    </ValueText>
                </TextContainer>
                <TextContainer>
                    <LabelText>Load value per card: </LabelText>
                    &nbsp;
                    <ValueText data-testid={'amount'}>
                        ${denomInDollars}
                    </ValueText>
                </TextContainer>
                <TextContainer>
                    <LabelText>
                        Status:{' '}
                        <GradientText data-testid="status">
                            {finalStatus}
                        </GradientText>
                    </LabelText>
                </TextContainer>
                {deliveryDetails?.latest_delivery_address && (
                    <LineItemDetailsPhysical
                        tracking={lineItem.tracking}
                        address={deliveryDetails?.latest_delivery_address ?? ''}
                        imbData={
                            !!imbData && isMultipleShipments ? imbData : null
                        }
                    />
                )}
            </LineItemInfoContainer>
        </LineItemContainer>
    )
}

export default BoxLineItemSummary
